import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

import SlidePc from '@/components/LayoutItems/Slide';
import SlidePcH5 from '@/componentsH5/LayoutItems/Slide';
import SingleTop from '@/components/LayoutItems/SingleTop';
import Grid from '@/components/LayoutItems/Grid';
import SingleEnd from '@/components/LayoutItems/SingleEnd';

export default function IndexMain({ homeData }) {
    const { useRouter, isMobile } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const Slide = isMobile ? SlidePcH5 : SlidePc;
    return (
        <div className={css.indexMain} style={{ minHeight: '1000px' }}>
            {homeData?.pageLayoutList?.map((item) => {
                if (item.type === 'SLIDE') {
                    return <Slide key={item.id} initData={item.detailList} locale={locale} router={router} />;
                }

                if (item.type === 'SINGLE_TOP') {
                    return <SingleTop key={item.id} initData={item.detailList} locale={locale} router={router} />;
                }

                if (item.type === 'GRID') {
                    return <Grid key={item.id} initData={item.detailList} locale={locale} router={router} />;
                }

                if (item.type === 'SINGLE_END') {
                    return <SingleEnd key={item.id} initData={item.detailList} locale={locale} router={router} />;
                }
            })}
        </div>
    );
}
